import React, { useState, useContext, useEffect } from "react";
import { PortfolioContext } from "../context";
import { useInView } from "react-intersection-observer";
import Modal from "./Modal";
import { motion } from "framer-motion";
import { RxOpenInNewWindow } from "react-icons/rx";
import { BsSpotify } from "react-icons/bs";
import { MdQuiz } from "react-icons/md";
import "../css/projects.css";

export default function Projects(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentModal, setCurrentModal] = useState("");

  const { setActiveTab } = useContext(PortfolioContext);
  const { ref: projectRef, inView } = useInView();

  useEffect(() => {
    if (inView) {
      setActiveTab("Projects");
    }
    console.log("Projects", inView);
  }, [inView]);

  const handleButtonClick = (cardName) => {
    if (!modalOpen) {
      setCurrentModal(cardName);
    } else {
      setCurrentModal("");
    }
    setModalOpen(!modalOpen);
  };

  const close = () => {
    setModalOpen(false);
  };
  const open = () => {
    setModalOpen(true);
  };

  return (
    <section className="ProjectsSection" id="projects">
      <div className="ProjectsTitle">
        <span>Projects</span>
        <div id="projectnavtrigger" ref={projectRef}></div>
      </div>
      <div className="ProjectsContent">
        <a
          href="#projects"
          className="ProjectCard"
          onClick={() => handleButtonClick("Spoofy")}
        >
          <div className="ExpandIcon">
            <a href="https://spoofy.jaredfipps.com/" target="_blank">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.85 }}
              >
                <RxOpenInNewWindow size={28}></RxOpenInNewWindow>
              </motion.button>
            </a>
          </div>
          <div className="ProjectCardContents">
            <h2 className="ProjectCardHeader">Spoofy</h2>
            <h4>Track your Spotify listening habits!</h4>
          </div>
        </a>
        <a
          href="#projects"
          className="ProjectCard"
          onClick={() => handleButtonClick("Quizmo")}
        >
          <div className="ExpandIcon">
            <a href="https://quizmo.jaredfipps.com/" target="_blank">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.85 }}
              >
                <RxOpenInNewWindow size={28}></RxOpenInNewWindow>
              </motion.button>
            </a>
          </div>
          <div className="ProjectCardContents">
            <h2 className="ProjectCardHeader">Quizmo</h2>
            <h4>Take quizzes and compete with the world!</h4>
          </div>
        </a>
        {/* <a
          href="#projects"
          className="ProjectCard"
          onClick={() => handleButtonClick("Apptrack")}
        >
          <div className="ExpandIcon">
            <a href="https://apptrack.jaredfipps.com/" target="_blank">
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.85 }}
              >
                <RxOpenInNewWindow size={28}></RxOpenInNewWindow>
              </motion.button>
            </a>
          </div>
          <div className="ProjectCardContents">
            <h2 className="ProjectCardHeader">App Track</h2>
            <h4>Manage your next career move!</h4>
          </div>
        </a> */}
      </div>
      {modalOpen && (
        <Modal
          modalOpen={modalOpen}
          handleClose={close}
          openedModal={currentModal}
        ></Modal>
      )}
    </section>
  );
}
